// Мини-задания правил A2 (тикет 06 .scratch/grammar-unify) — пишутся по урокам, частями.
import type { MiniSet } from './types'
import { MINI_A2_1 } from './a2-1'
import { MINI_A2_2 } from './a2-2'
import { MINI_A2_3 } from './a2-3'

export const MINI_A2: MiniSet[] = [...MINI_A2_1, ...MINI_A2_2, ...MINI_A2_3]
